import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initMonitoring } from './lib/monitoring'
import { capturarOrigen } from './lib/origen'
import './styles/global.css'

void initMonitoring()
// Antes de que el inicio de sesión cambie la URL
capturarOrigen(location.search)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
